(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[732],{

/***/ 285:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/virtual-care",
      function () {
        return __webpack_require__(2945);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 3976:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ SEO_SEO; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(6042);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
;// CONCATENATED MODULE: ./lib/seo-config.js
var SITE_CONFIG = {
    name: "Evry Health",
    url: "https://www.evryhealth.com",
    defaultOgImage: "https://www.evryhealth.com/og-image.png",
    twitterCard: "summary_large_image"
};
var PAGE_SEO = {
    "": {
        title: "Evry Health | Modern Health Insurance for Texas Employers & Members",
        description: "Evry Health offers transparent, member-first health insurance for Texas employers (51+ employees) and their members — with $0 telehealth, no copays, no deductibles, and a personalized care team.",
        ogDescription: "Transparent, member-first health insurance for Texas employers and members. No copays. No deductibles. $0 telehealth.",
        twitterTitle: "Evry Health",
        twitterDescription: "Modern health insurance for Texas employers and members."
    },
    "admission-notification": {
        title: "Inpatient Admission Notification | Evry Health",
        description: "How to submit inpatient admission notifications to Evry Health to ensure timely, accurate claims processing.",
        ogDescription: "How to submit inpatient admission notifications to Evry Health.",
        twitterTitle: "Admission Notification | Evry Health",
        twitterDescription: "Submit inpatient admission notifications to Evry Health."
    },
    careers: {
        title: "Careers at Evry Health | Join Our Team",
        description: "We're making health insurance work again. Explore open roles at Evry Health in Dallas, Texas.",
        twitterTitle: "Careers at Evry Health",
        twitterDescription: "Explore open roles at Evry Health in Dallas, Texas."
    },
    "community-resources": {
        title: "Texas Community Resources for Members | Evry Health",
        description: "A curated list of local community, health, food, and legal resources across Texas for Evry Health members.",
        twitterTitle: "Texas Community Resources | Evry Health",
        twitterDescription: "Community, health, food, and legal resources for Evry Health members in Texas."
    },
    "contact-us": {
        title: "Contact Evry Health | Get a Quote",
        description: "Get in touch with Evry Health for plan quotes, member support, or general questions. Call 1-855-579-3879.",
        ogDescription: "Get in touch with Evry Health for plan quotes, member support, or general questions.",
        twitterTitle: "Contact Evry Health",
        twitterDescription: "Get a quote or ask us anything. Call 1-855-579-3879."
    },
    faqs: {
        title: "Frequently Asked Questions | Evry Health",
        description: "Answers to common questions about Evry Health plans, coverage, virtual care, and member benefits.",
        twitterDescription: "Answers to common questions about Evry Health plans and coverage."
    },
    forms: {
        title: "Forms & Notices | Evry Health",
        description: "Download member and provider forms, notices, and resources from Evry Health.",
        twitterDescription: "Download forms and notices from Evry Health."
    },
    fwa: {
        title: "Report Fraud, Waste & Abuse | Evry Health",
        description: "How Evry Health members and providers can report suspected fraud, waste, or abuse.",
        twitterDescription: "Report suspected fraud, waste, or abuse to Evry Health."
    },
    "how-we-compare": {
        title: "How Evry Health Compares | Plan Comparison",
        description: "Compare Evry Health plans against traditional carriers — no deductibles, no copays, $0 virtual care, and transparent premiums.",
        ogDescription: "Compare Evry Health plans against traditional carriers — no deductibles, no copays, $0 virtual care.",
        twitterTitle: "How Evry Health Compares",
        twitterDescription: "Compare Evry Health plans against traditional carriers."
    },
    "how-we-do-it": {
        title: "How Evry Health Works | Built for Modern Workforces",
        description: "Evry Health is built for the modern business and the mobile workforce. See how our health insurance plans work.",
        twitterTitle: "How Evry Health Works",
        twitterDescription: "Built for the modern business and the mobile workforce."
    },
    "join-the-evry-network": {
        title: "Join the Evry Health Provider Network",
        description: "Apply to join the Evry Health provider network. Faster payments. Transparent terms.",
        twitterTitle: "Join the Evry Health Network",
        twitterDescription: "Apply to join the Evry Health provider network."
    },
    login: {
        title: "Sign In | Evry Health",
        description: "Sign in to the Evry Health member portal.",
        noindex: true
    },
    "meet-your-new-team": {
        title: "Meet Your Evry Health Care Team",
        description: "Every Evry Health member gets a dedicated team of nurses, nutritionists, and doctors — included at no extra cost.",
        ogDescription: "Every member gets a dedicated team of nurses, nutritionists, and doctors — at no extra cost.",
        twitterDescription: "A dedicated team of nurses, nutritionists, and doctors — included at no extra cost."
    },
    members: {
        title: "Member Registration | Evry Health",
        description: "Register for your Evry Health member portal account.",
        noindex: true
    },
    mobileapp: {
        title: "Evry Health Mobile App | Manage Your Plan On the Go",
        description: "Download the Evry Health mobile app to view your ID card, find providers, message your care team, and more.",
        ogDescription: "Download the Evry Health mobile app to view your ID card, find providers, and message your care team.",
        twitterTitle: "Evry Health Mobile App",
        twitterDescription: "Manage your health plan on the go with the Evry Health app."
    },
    news: {
        title: "News & Press | Evry Health",
        description: "The latest news, press releases, and announcements from Evry Health.",
        twitterDescription: "The latest news and announcements from Evry Health."
    },
    "non-discrimination-policy": {
        title: "Non-Discrimination Policy | Evry Health",
        description: "Evry Health's commitment to non-discrimination and language assistance for members.",
        twitterDescription: "Non-discrimination and language assistance for all members."
    },
    "our-story": {
        title: "Our Story | Evry Health",
        description: "Evry Health is on a mission to build the health insurance company we've always wanted for ourselves.",
        ogDescription: "We're on a mission to build the health insurance company we've always wanted for ourselves.",
        twitterDescription: "Building the health insurance company we've always wanted."
    },
    partners: {
        title: "Partners | Evry Health",
        description: "The partners and providers Evry Health works with to deliver modern health insurance.",
        twitterDescription: "Partners and providers delivering modern health insurance."
    },
    "prior-auth-list-updates": {
        title: "Prior Authorization List Updates | Evry Health",
        description: "Recent updates to the Evry Health prior authorization list for providers.",
        twitterDescription: "Recent updates to the prior authorization list for providers."
    },
    "prior-auth-tool": {
        title: "Prior Authorization Tool | Evry Health for Providers",
        description: "Look up whether a procedure requires prior authorization with Evry Health.",
        twitterTitle: "Prior Authorization Tool | Evry Health",
        twitterDescription: "Check if prior authorization is required for a procedure."
    },
    "prior-authorization": {
        title: "Prior Authorization | Evry Health for Providers",
        description: "Information for providers on which procedures require prior authorization with Evry Health.",
        ogDescription: "Provider resources for prior authorization with Evry Health.",
        twitterTitle: "Prior Authorization | Evry Health",
        twitterDescription: "Provider resources for prior authorization with Evry Health."
    },
    "privacy-policy": {
        title: "Privacy Policy | Evry Health",
        description: "How Evry Health collects, uses, and protects your personal and health information.",
        twitterDescription: "How Evry Health protects your personal and health information."
    },
    providerdirectory: {
        title: "Provider Directory | Evry Health",
        description: "Find in-network providers with the Evry Health provider directory.",
        noindex: true
    },
    "request-to-join": {
        title: "Request to Join | Evry Health Network",
        description: "Submit a request to join the Evry Health provider network. Simple application process.",
        ogDescription: "Submit a request to join the Evry Health provider network.",
        twitterTitle: "Request to Join | Evry Health",
        twitterDescription: "Join the Evry Health provider network."
    },
    "retrospective-reviews": {
        title: "Retrospective Reviews | Evry Health for Providers",
        description: "Learn how Evry Health determines coverage after treatment has been provided.",
        twitterTitle: "Retrospective Reviews | Evry Health",
        twitterDescription: "How Evry Health determines coverage after treatment."
    },
    rewards: {
        title: "Member Rewards | Evry Health",
        description: "Earn rewards for staying healthy as an Evry Health member.",
        twitterDescription: "Earn rewards for staying healthy with Evry Health."
    },
    terms: {
        title: "Terms of Use | Evry Health",
        description: "Terms of use for the Evry Health website and digital services.",
        twitterDescription: "Terms of use for Evry Health website and services."
    },
    "virtual-care": {
        title: "$0 Virtual Care & Telehealth | Evry Health",
        description: "Talk to a board-certified physician 24/7 for $0. On-demand virtual care included with every Evry Health plan.",
        twitterDescription: "Talk to a board-certified physician 24/7 for $0."
    },
    "why-choose-evry": {
        title: "Why Choose Evry Health | Texas Health Insurance",
        description: "See why Texas employers choose Evry Health: no copays, no deductibles, $0 telehealth, and a personalized member care team.",
        twitterTitle: "Why Choose Evry Health",
        twitterDescription: "See why Texas employers choose Evry Health: no copays, no deductibles, $0 telehealth."
    }
};
function getPageSeo(slug) {
    var page = PAGE_SEO[slug] || {};
    var title = page.title || SITE_CONFIG.name;
    var description = page.description || "";
    var ogTitle = page.ogTitle || title;
    var ogDescription = page.ogDescription || description;
    var ogImage = page.ogImage || SITE_CONFIG.defaultOgImage;
    var twitterTitle = page.twitterTitle || ogTitle;
    var twitterDescription = page.twitterDescription || ogDescription;
    var twitterImage = page.twitterImage || ogImage;
    var noindex = page.noindex || false;
    var url = slug === "" ? "".concat(SITE_CONFIG.url, "/") : "".concat(SITE_CONFIG.url, "/").concat(slug);
    return {
        title: title,
        description: description,
        url: url,
        ogTitle: ogTitle,
        ogDescription: ogDescription,
        ogImage: ogImage,
        twitterTitle: twitterTitle,
        twitterDescription: twitterDescription,
        twitterImage: twitterImage,
        noindex: noindex
    };
}

;// CONCATENATED MODULE: ./components/SEO/SEO.js





var SEO = function() {
    var ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, slug = ref.slug, overrides = ref.overrides;
    var router = (0,next_router.useRouter)();
    var resolvedSlug = slug !== undefined ? slug : router.pathname.replace(/^\//, "");
    var resolved = getPageSeo(resolvedSlug);
    var seo = overrides ? (0,_object_spread/* default */.Z)({}, resolved, overrides) : resolved;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                children: seo.title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "description",
                content: seo.description
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:title",
                content: seo.ogTitle
            }, "title"),
            seo.noindex && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "robots",
                content: "noindex,follow"
            }),
            !seo.noindex && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "canonical",
                        href: seo.url
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:type",
                        content: "website"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:site_name",
                        content: SITE_CONFIG.name
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:url",
                        content: seo.url
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:description",
                        content: seo.ogDescription
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:image",
                        content: seo.ogImage
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:card",
                        content: SITE_CONFIG.twitterCard
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:title",
                        content: seo.twitterTitle
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:description",
                        content: seo.twitterDescription
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:image",
                        content: seo.twitterImage
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var SEO_SEO = (SEO);


/***/ }),

/***/ 2945:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _components_SEO_SEO__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3976);
/* harmony import */ var _layout_Layout__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9875);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _styles_section_module_css__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(3538);
/* harmony import */ var _styles_section_module_css__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_styles_section_module_css__WEBPACK_IMPORTED_MODULE_4__);





var VirtualCare = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_SEO_SEO__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_layout_Layout__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "relative",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "absolute inset-x-0 bottom-0 h-1/2"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "mx-auto",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "relative",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "absolute inset-0",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                    className: "object-cover w-full h-full",
                                                    src: "conferenceroomtalk.png",
                                                    alt: "Team meeting in a conference room"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: "relative max-w-screen-xl px-4 py-16 mx-auto md:py-16 lg:py-32",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h1", {
                                                        className: "text-3xl tracking-tight md:text-5xl",
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                className: "block text-blue-dark",
                                                                children: "No copay. No deductible."
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                className: "block py-2 text-globeGreen",
                                                                children: "Talk to a board-certified physician 24/7 for $0."
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                        className: "max-w-lg mt-6 text-xl text-grey sm:max-w-3xl",
                                                        children: "Available on-demand by phone and video. Just the primary and specialty care you want, when you need it most."
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                        href: "https://doctorondemand.com/microsite/evryhealth/",
                                                        target: "_blank",
                                                        rel: "noreferrer",
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                                            className: "inline-block px-10 py-2 mt-8 text-xl bg-transparent border-2 text-blue border-blue hover:bg-blue hover:text-white-light",
                                                            children: "Sign in"
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("main", {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "max-w-screen-xl px-4 py-12 mx-auto md:py-0 sm:px-6 lg:px-8",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "lg:grid lg:grid-cols-2 lg:gap-8 lg:items-center",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: "px-4 lg:col-span-1",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h2", {
                                                        className: "text-4xl tracking-tight font-extralight",
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                className: "block text-blue-dark",
                                                                children: "Evry makes it easy"
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                className: "block text-blue",
                                                                children: "to get great virtual care."
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                        className: "max-w-lg mt-6 text-lg text-grey sm:max-w-3xl",
                                                        children: "We offer 24/7 telehealth access, with unlimited visits to primary care and certain specialists."
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "mt-8 lg:col-span-1 md:mt-0",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "flex items-center justify-center h-full",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("figure", {
                                                        className: "".concat((_styles_section_module_css__WEBPACK_IMPORTED_MODULE_4___default().sectionImageRightVirtualCare)),
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                            className: "".concat((_styles_section_module_css__WEBPACK_IMPORTED_MODULE_4___default().virtualCareLady), " h-full w-full object-cover"),
                                                            src: "https://content.evryhealth.com/MarketingImages/public%20(12).webp",
                                                            alt: "Lady smiling"
                                                        })
                                                    })
                                                })
                                            })
                                        ]
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "bg-white",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "max-w-screen-xl px-8 py-16 mx-auto lg:px-8",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "lg:grid lg:grid-cols-2 lg:gap-8 lg:items-center",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    className: "lg:col-span-1",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                                            className: "text-4xl tracking-tight text-blue-dark",
                                                            children: "All from your home for $0."
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                                                            className: "pt-6 text-xl text-darkBlue",
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                                                    className: "mt-4",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("object", {
                                                                            className: "inline-block h-6",
                                                                            type: "image/svg+xml",
                                                                            data: "checkmark.svg"
                                                                        }),
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                            className: "inline pl-4",
                                                                            children: "Post-visit lab work & imaging"
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                                                    className: "mt-4",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("object", {
                                                                            className: "inline-block h-6",
                                                                            type: "image/svg+xml",
                                                                            data: "checkmark.svg"
                                                                        }),
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                            className: "inline pl-4",
                                                                            children: "New prescriptions"
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                                                    className: "mt-4",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("object", {
                                                                            className: "inline-block h-6",
                                                                            type: "image/svg+xml",
                                                                            data: "checkmark.svg"
                                                                        }),
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                            className: "inline pl-4",
                                                                            children: "Renew old prescriptions"
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                                                    className: "mt-4",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("object", {
                                                                            className: "inline-block h-6",
                                                                            type: "image/svg+xml",
                                                                            data: "checkmark.svg"
                                                                        }),
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                            className: "inline pl-4",
                                                                            children: "Follow-up appointments"
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                                                    className: "mt-4",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("object", {
                                                                            className: "inline-block h-6",
                                                                            type: "image/svg+xml",
                                                                            data: "checkmark.svg"
                                                                        }),
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                            className: "inline pl-4",
                                                                            children: "Control over your own medical records"
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                                                    className: "mt-4",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("object", {
                                                                            className: "inline-block h-6",
                                                                            type: "image/svg+xml",
                                                                            data: "x-red.svg"
                                                                        }),
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                            className: "inline pl-4",
                                                                            children: "Waiting weeks to get into the doctor’s office"
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                                                    className: "mt-4",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("object", {
                                                                            className: "inline-block h-6",
                                                                            type: "image/svg+xml",
                                                                            data: "x-red.svg"
                                                                        }),
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                            className: "inline pl-4",
                                                                            children: "Office visits"
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                                                    className: "mt-4",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("object", {
                                                                            className: "inline-block h-6",
                                                                            type: "image/svg+xml",
                                                                            data: "x-red.svg"
                                                                        }),
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                            className: "inline pl-4",
                                                                            children: "Copays"
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "lg:col-span-1",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        className: "flex items-center justify-center h-full mt-10 md:mt-0"
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "max-w-screen-xl px-4 py-12 mx-auto md:py-0 sm:px-6 lg:px-8",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "lg:grid lg:grid-cols-2 lg:gap-8 lg:items-center",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: "py-32 lg:col-span-1",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                                        className: "pb-12 text-2xl tracking-tight font-extralight sm:text-3xl lg:text-4xl",
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                            className: "block text-blue-dark",
                                                            children: "How It Works"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ol", {
                                                        className: "".concat((_styles_section_module_css__WEBPACK_IMPORTED_MODULE_4___default().numberedList), " pl-6 md:pl-16 text-xl text-grey"),
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                                className: "py-3",
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                    children: "Select “Talk to a Doctor Now” on your Member Portal or Evry Mobile App."
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                                className: "py-3",
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                    children: "Complete a quick, one-time questionnaire and profile for you and your children."
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                                className: "py-3",
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                    children: "Pick the type of doctor you need and whether you want to visit them by phone, web, or app."
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                                className: "py-3",
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                    children: "Choose to see someone immediately on-demand or schedule an appointment with your preferred doctor."
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                                className: "py-3",
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                    children: "See your doctor from the convenience of anywhere."
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                                className: "py-3",
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                    children: "You’ll get summary notes back from the doctor after your visit."
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "lg:col-span-1",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "flex items-center justify-center h-full",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                        className: "".concat((_styles_section_module_css__WEBPACK_IMPORTED_MODULE_4___default().virtualCarePhone), " object-cover"),
                                                        src: "Virtual_Care_Phone.png",
                                                        alt: "Phone with profile contact "
                                                    })
                                                })
                                            })
                                        ]
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
                                className: "bg-white-light",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                        className: "text-4xl font-light text-center text-darkBlue",
                                        children: "Covered Specialties."
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "grid grid-cols-12 pt-16 text-center",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: "col-span-12 py-4 md:col-span-4 md:py-16 md:px-16",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("object", {
                                                        className: "py-2 mx-auto",
                                                        data: "stethescope-blue.svg",
                                                        alt: "stethoscope"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                                                        className: "text-2xl md:text-3xl text-darkBlue",
                                                        children: "General Medical"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                        className: "px-12 py-6 md:px-10 text-grey-dark",
                                                        children: "See experienced U.S. board-certified adult and pediatric doctors who can help you with anything. From cold and flu to allergies to COVID-19, these physicians can help diagnose, treat, and prescribe medication for you."
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: "col-span-12 py-8 md:col-span-4 md:px-16",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("object", {
                                                        className: "py-2 mx-auto md:py-6",
                                                        data: "sexual-blue.svg",
                                                        alt: "stethoscope"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                                                        className: "text-2xl md:text-3xl text-darkBlue",
                                                        children: "Sexual Health"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                        className: "px-12 py-6 md:px-10 text-grey-dark",
                                                        children: "Get confidential lab tests for common sexually transmitted diseases along with a consultation with specially trained physicians. Results are always completely confidential and never reported back to us or your employer, so that you can get the care you need with the privacy you deserve."
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: "col-span-12 py-8 md:col-span-4 md:py-16 md:px-16",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("object", {
                                                        className: "py-2 mx-auto md:py-2",
                                                        data: "smileyface-blue.svg",
                                                        alt: "stethoscope"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                                                        className: "text-2xl md:text-3xl text-darkBlue",
                                                        children: "Behavioral Health"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                        className: "px-12 py-6 md:px-0 text-grey-dark",
                                                        children: "We‘ve gone through great lengths to make sure board-certified psychiatrists, licensed psychologists, and therapists are available to serve you wherever you feel most comfortable. Whether you‘re battling severe depression or just need an outside perspective, we encourage you to take full advantage of these professionals."
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (VirtualCare);


/***/ }),

/***/ 3538:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"fadingOut":"section_fadingOut__ZY4x7","fadeOut":"section_fadeOut__E4vF6","fadingIn":"section_fadingIn__Q1dn6","fadeIn":"section_fadeIn__z9Mx8","section-bar":"section_section-bar__p2nXY","sectionImageRight":"section_sectionImageRight__aPuEP","whyChooseEvrysectionImageRight":"section_whyChooseEvrysectionImageRight__yInbM","prevArrow":"section_prevArrow__cyQub","nextArrow":"section_nextArrow__1wnkz","meetYourNewTeamSectionImageRight":"section_meetYourNewTeamSectionImageRight__AmkxL","sectionImageRightVirtualCare":"section_sectionImageRightVirtualCare__Wzv_i","virtualCareLady":"section_virtualCareLady__WgyzK","noTextWrap":"section_noTextWrap__PSVA5","ulclass":"section_ulclass__3lngx","ul":"section_ul__7HZsf","numberedList":"section_numberedList__eyVoS","chekmarkList":"section_chekmarkList__MNsU0","differenceBackground":"section_differenceBackground__Y2rnw","virtualCarePhone":"section_virtualCarePhone__cLyjo","homepagePhoneOne":"section_homepagePhoneOne__Fdlng","homepagePhoneTwo":"section_homepagePhoneTwo__E8F1p","cardBoxShadow":"section_cardBoxShadow__dwDsj","transformPhone":"section_transformPhone__4KwcT","transformDFWMap":"section_transformDFWMap__LXijJ","transformMobileText":"section_transformMobileText__kS3hI","greyCell":"section_greyCell__IH1f_","fileInput":"section_fileInput__ZgDbf","joinEvryNetworkUl":"section_joinEvryNetworkUl__YqtDF"};

/***/ }),

/***/ 9008:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(5443)


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [87,875,774,888,179], function() { return __webpack_exec__(285); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);